/**
 * TRCloseCountdown - Aviso discreto "TR cierra en X min".
 * Trade Republic cierra a las 23:00 (hora Madrid). Este chip solo aparece en la
 * última hora antes del cierre (22:00-23:00) en días laborables, para avisar de
 * la última ventana de operativa. Se oculta el resto del tiempo.
 */
import React, { useState, useEffect } from 'react';
import { Timer } from '@phosphor-icons/react';
import { getMadridTime } from '../utils/marketHours';

const CLOSE_MINUTE = 23 * 60; // 23:00 Madrid
const WINDOW_MIN = 60;        // mostrar solo en los 60 min previos

const computeRemaining = () => {
  const { hour, minutes, dayOfWeek } = getMadridTime();
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
  if (!isWeekday) return null;
  const nowMin = hour * 60 + minutes;
  const rem = CLOSE_MINUTE - nowMin;
  if (rem <= 0 || rem > WINDOW_MIN) return null;
  return rem;
};

const TRCloseCountdown = () => {
  const [remaining, setRemaining] = useState(computeRemaining);

  useEffect(() => {
    const tick = () => setRemaining(computeRemaining());
    tick();
    const interval = setInterval(tick, 15000); // refrescar cada 15s
    return () => clearInterval(interval);
  }, []);

  if (remaining == null) return null;

  const urgent = remaining <= 5;

  return (
    <div
      data-testid="tr-close-countdown"
      title="El mercado (Kapital) cierra su ventana operativa a las 23:00 (hora Madrid). Última oportunidad para operar hoy."
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold tracking-wide select-none transition-colors ${
        urgent
          ? 'bg-red-500/15 text-red-300 border border-red-500/40'
          : 'bg-gold-500/10 text-gold-300 border border-gold-500/30'
      }`}
      style={urgent ? { animation: 'pulse 1.2s ease-in-out infinite' } : undefined}
    >
      <Timer size={14} weight="bold" className={urgent ? 'animate-pulse' : ''} />
      <span className="whitespace-nowrap">Kapital cierra en {remaining} min</span>
    </div>
  );
};

export default TRCloseCountdown;
